export default "{\n    \"label\": \"Manufacturer\"\n}\n"